// extracted by mini-css-extract-plugin
export default {"caption":"PhuHuynhChildList_caption__2GLpm","list_horizontal":"PhuHuynhChildList_list_horizontal__+Y1wA","list_horizontal_item":"PhuHuynhChildList_list_horizontal_item__TiBNE"};